import styled from '@emotion/styled';
import {Button} from '@bosch/react-frok';

export const PopoverMenuWrapper = styled.nav`
    .m-popover__content {
        padding: 0;
    }

    .a-menu-item {
        padding: 0;
        margin: 0;
        &:nth-of-type(1) {
            z-index: 99;
        }
    }
`;

export const AddButton = styled(Button)`
    margin: 0.5rem;
    min-width: 32px;
    > .a-icon.a-button__icon {
        padding: 0.25rem;
    }
`;
